import styled from 'styled-components'

export const Separator = styled.div`
  height: 8px;
  width: 100vw;
  margin-left: -24px;

  background-color: var(--gray100);
`
export const SeparatorDashed = styled.div`
  border-top: 2px dotted var(--gray200);
  margin: -6px 0 8px 0;
`
